var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{'w3-text-red': (_vm.value < 0 & _vm.colored), 'w3-text-green': (_vm.value >= 0 & _vm.colored)}},[_vm._v(_vm._s(_vm.formatedAmount)+" "+_vm._s(_vm.currency.symbol))])}
var staticRenderFns = []

export { render, staticRenderFns }